import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const LegaleseComponent = ({ just, text }: { just?: 'privacy' | 'cookie' | 'tos'; text?: string }) => {
  const { t } = useTranslation();

  const TITLES = {
    PRIVACY: t('legalese.labels.privacy'),
    COOKIE: t('legalese.labels.cookie'),
    TOS: t('legalese.labels.tos'),
    CONTACTS: t('legalese.labels.contactUs'),
  };

  const Copyright = () => (
    <span>
      &copy; {new Date().getFullYear()} {process.env.REACT_APP_TITLE}
    </span>
  );

  const Separator = () => <span className={'mx-1'}>&bull;</span>;

  const PrivacyPolicyTrigger = ({ className = '' }) => <Link className={className} to={'/legal/privacy'}>{text || TITLES.PRIVACY}</Link>;
  const CookiePolicyTrigger = ({ className = '' }) => <Link className={className} to={'/legal/cookie'}>{text || TITLES.COOKIE}</Link>;
  const TermsOfServiceTrigger = ({ className = '' }) => <Link className={className} to={'/legal/tos'}>{text || TITLES.TOS}</Link>;

  if (just == 'privacy') return <PrivacyPolicyTrigger />;
  if (just == 'cookie') return <CookiePolicyTrigger />;
  if (just == 'tos') return <TermsOfServiceTrigger />;

  return (
    <>
      <Copyright />
      <Separator />
      <Link to={'/company-info'}>{t('legalese.labels.informazioniSocietarie')}</Link>
      <Separator />
      <PrivacyPolicyTrigger />
      <Separator />
      <CookiePolicyTrigger />
      <Separator />
      <TermsOfServiceTrigger />
      <Separator />
      <Link to={'/contact-us'}>{t('legalese.labels.contactUs')}</Link>
    </>
  );
};

export { LegaleseComponent as Legalese };
